"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var _DefaultLocale = require("../../config/DefaultLocale");

var _AaSuggestionsRequestParams = _interopRequireDefault(require("../../utils/AaSuggestionsRequestParams"));

var _SearchWidget = _interopRequireDefault(require("./SearchWidget"));

var _AaSearchWidgetProvider = require("./models/AaSearchWidgetProvider.model");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HotelSearchWidgetProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HotelSearchWidgetProvider, _React$Component);

  var _super = _createSuper(HotelSearchWidgetProvider);

  function HotelSearchWidgetProvider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HotelSearchWidgetProvider);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setLocale", function (localeSpecified) {
      var locale = (0, _DefaultLocale.getValidLocale)(localeSpecified);
      var store = _this.props.store;

      _this.setState({
        locale: locale
      });

      store.dispatch((0, _uiUtils.bulkUpdateStates)({
        locale: locale
      }));
    });
    var _this$props$controls = _this.props.controls,
        _locale = _this$props$controls.locale,
        environment = _this$props$controls.environment;
    var validLocale = (0, _DefaultLocale.getValidLocale)(_locale);
    _this.state = {
      locale: validLocale
    };
    var _this$props = _this.props,
        clientId = _this$props.clientId,
        _store = _this$props.store;

    _AaSuggestionsRequestParams["default"].create(environment, clientId);

    _store.dispatch((0, _uiUtils.bulkUpdateStates)({
      locale: validLocale
    }));

    return _this;
  }

  (0, _createClass2["default"])(HotelSearchWidgetProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.locale !== this.props.controls.locale) {
        this.setLocale(this.props.controls.locale);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.controls.locale !== this.props.controls.locale) {
        this.setLocale(this.props.controls.locale);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var controls = this.props.controls;
      return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
        store: this.props.store
      }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.LayoutContextProvider, null, /*#__PURE__*/_react["default"].createElement(_SearchWidget["default"], {
        controls: {
          environment: controls.environment,
          locale: this.state.locale,
          currency: controls.currency || 'myr',
          token: controls.token,
          is_login: controls.is_login,
          preFill: controls.preFill,
          agentId: controls.agentId,
          forceMobileView: controls.forceMobileView,
          isSearchAgain: controls.isSearchAgain,
          searchHandler: controls.searchHandler,
          chinaDisclaimerService: controls.chinaDisclaimerService,
          closeSearchWidget: controls.closeSearchWidget,
          isCalendarOpenedByDeepLink: controls.isCalendarOpenedByDeepLink
        },
        navigation: this.props.navigation
      })));
    }
  }]);
  return HotelSearchWidgetProvider;
}(_react["default"].Component);

var _default = HotelSearchWidgetProvider;
exports["default"] = _default;